import React from "react";
import { useTranslation } from "react-i18next";

import { AIHazardStatus } from "./types";

interface StatusBadgeProps {
  status: AIHazardStatus;
  // Accepted hazard whose real risk has meanwhile been deleted from
  // project.risks — the card shows a plain "accepted" badge variant instead
  // of a broken deep-link (plan §5).
  acceptedRiskMissing?: boolean;
}

const STATUS_DOT: Record<AIHazardStatus, string> = {
  [AIHazardStatus.suggested]: "bg-blue-400",
  [AIHazardStatus.generated]: "bg-cyan-500",
  [AIHazardStatus.accepted]: "bg-green-500",
  [AIHazardStatus.dismissed]: "bg-gray-400",
};

export const StatusBadge = ({
  status,
  acceptedRiskMissing,
}: StatusBadgeProps) => {
  const { t } = useTranslation();

  const labelKey =
    status === AIHazardStatus.accepted && acceptedRiskMissing
      ? "risks.ai.status.acceptedMissing"
      : `risks.ai.status.${status}`;

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className={`h-1.5 w-1.5 rounded-full flex-shrink-0 ${STATUS_DOT[status]}`}
        aria-hidden="true"
      />
      <span className="text-xs font-medium text-gray-600">{t(labelKey)}</span>
    </span>
  );
};
